import React from "react";
import styled from "styled-components";
import Spinner from "Components/Spinner";

const SignIn = ({ loading }) => {
  return (
    <Container>
      <Greeting>
        <span>간편하게 로그인하고</span>
        <span>자소서를 첨삭 받아보세요.</span>
      </Greeting>
      <div>
        <button id="KAKAO-LOGIN"></button>
        {loading && (
          <Loader>
            <Spinner fontSize="4px" color={{ r: "58", g: "29", b: "30" }} />
          </Loader>
        )}
      </div>
    </Container>
  );
};

export default SignIn;

const Container = styled.div`
  width: 420px;
  margin: 120px auto;
  padding: 40px 20px 40px 20px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > div {
    position: relative;
  }

  button {
    all: unset;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Greeting = styled.p`
  width: 100%;
  text-align: center;
  font-size: 24px;
  line-height: 160%;
  margin-bottom: 30px;

  span:first-child {
    display: block;
  }
  span:last-child {
    display: block;
  }
`;

const Loader = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffeb00;
  border-radius: 9px;
`;
